import { Stack } from "@mui/material";
import FilterChip from "./FilterChip";
import { useBoundStore } from "useStore";

export default function StateFilterChip() {
  const selectedStatus = useBoundStore((state) => state.soAdminSelectedStatus);
  if (selectedStatus === null) return null;

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      <FilterChip filterName="Estado" title={selectedStatus.nombre_estado} />
    </Stack>
  );
}
